import React, { useState } from "react";
import { axiosSalary } from "../../Components/api/axiosInstance";

const AddEditAttendancePage = ({ groupId, restId, empId, onClose, onSuccess }) => {
  const [punchTime, setPunchTime] = useState(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const isoPunchTime = new Date(punchTime).toISOString();

      await axiosSalary.post("/AttendanceLog/manual-punch", {
        groupId,
        restId,
        empId,
        punchTime: isoPunchTime,
      });

      onSuccess(isoPunchTime);
    } catch (err) {
      console.error(err);
      alert("Failed to save punch");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg"
      >
        <h3 className="text-lg font-semibold mb-4">Manual Punch</h3>

        <label className="block text-sm font-medium mb-1">Punch Time</label>
        <input
          type="datetime-local"
          value={punchTime}
          onChange={(e) => setPunchTime(e.target.value)}
          className="w-full border rounded-lg p-2 mb-4"
          required
        />

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-lg border"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={saving}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddEditAttendancePage;